export const DATE_FORMAT = 'DD/MM/YYYY HH:mm';
export const ONLY_DATE_FORMAT = 'DD/MM/YYYY HH:mm';
